import fetcher from '../fetcher';

// Types
export interface Bouwheer {
	no?: number;
	id: string; // "B001"
	name: string;
	type: string; // "PT"
	industrySector?: {
		id: number;
		sectorLevel1: string;
		sectorLevel2: string;
		sectorLevel3: string;
		sectorLevel4: string;
		sectorLevel5: string;
		industryClass: string;
		ecosystem: string;
		code: string;
		portofolioGuidelineId: number;
		portofolioGuideline: string;
	};
}

export interface BouwheerListRequest {
	page: number;
	pageSize: number;
	search?: {
		by: 'id' | 'name';
		value: string;
	};
}

export interface BouwheerListResponse {
	items: Bouwheer[];
	currentPage: number;
	pageSize: number;
	totalPages: number;
	totalCount: number;
}

export interface CreateBouwheerRequest {
	id: string;
	name: string;
	type: string;
	industrySectorCode: string;
}

export interface UpdateBouwheerRequest {
	id: string;
	name?: string;
	type?: string;
	industrySectorCode?: string;
}

// Services
export const getBouwheerList = (payload: BouwheerListRequest) => {
	return fetcher<BouwheerListResponse>({
		api: '/admin/bouwheer/list',
		method: 'POST',
		body: payload as unknown as Record<string, unknown>,
	});
};

export const createBouwheer = (payload: CreateBouwheerRequest) => {
	return fetcher<{ message: string }>({
		api: '/admin/bouwheer/add',
		method: 'POST',
		body: payload as unknown as Record<string, unknown>,
	});
};

export const updateBouwheer = (payload: UpdateBouwheerRequest) => {
	return fetcher<{ message: string }>({
		api: '/admin/bouwheer/update',
		method: 'POST',
		body: payload as unknown as Record<string, unknown>,
	});
};

export const deleteBouwheer = (id: string) => {
	return fetcher<{ message: string }>({
		api: `/admin/bouwheer/delete/${id}`,
		method: 'POST',
	});
};

// React Query Hooks (Optional, but good practice to export query keys/fns if used directly)
export const bouwheerKeys = {
	all: ['bouwheers'] as const,
	lists: () => [...bouwheerKeys.all, 'list'] as const,
	list: (filter: BouwheerListRequest) =>
		[...bouwheerKeys.lists(), filter] as const,
};
